"use client";

import { useAuth } from "@/providers/auth-provider";
import { useModal } from "@/providers/modal-provider";
import { ModalType } from "@/types/modal-type";

const Topbar = () => {
	const { isLoggedIn, isLoading, user } = useAuth();
	const { openModal } = useModal();
	const isVerified = user?.isVerified;

	const handleVerifyProfile = () => {
		openModal(ModalType.UpdateProfile);
	};

	return isLoggedIn && !isVerified && !isLoading ? (
		<div className="flex flex-wrap items-center justify-center gap-2 bg-brand-primary px-4 py-2 text-center text-sm text-gray-50 md:flex-nowrap md:px-0">
			<h4>
				<span className="font-semibold">Verify your profile.</span> Verified profiles gain more
				trust on our platform.
			</h4>
			<button
				type="button"
				onClick={handleVerifyProfile}
				className="flex items-center justify-start gap-x-1 rounded-md bg-white px-4 py-2 text-sm font-medium text-brand-primary"
			>
				<span>Verify</span>
			</button>
		</div>
	) : null;
};

export default Topbar;
